import React, { Component } from "react";
import { Toaster } from "sonner";
import AnnouncementBar from "./components/AnnouncementBar";
import Hero from "./components/Hero";
import Story from "./components/Story";
import Featured from "./components/Featured";
import MenuSection from "./components/MenuSection";
import Experience from "./components/Experience";
import OurSpace from "./components/OurSpace";
import Reviews from "./components/Reviews";
import PartyOrders from "./components/PartyOrders";
import Contact from "./components/Contact";
import WhatsAppFloat from "./components/WhatsAppFloat";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: false };
    }
    static getDerivedStateFromError() {
        return { error: true };
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: 48, textAlign: "center", fontFamily: "sans-serif" }}>
                    Something went wrong. Please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    return (
        <ErrorBoundary>
            <div className="min-h-screen bg-saga-cream">
                <AnnouncementBar />
                <main>
                    <Hero />
                    <Story />
                    <Featured />
                    <MenuSection />
                    <Experience />
                    <OurSpace />
                    <Reviews />
                    <PartyOrders />
                    <Contact />
                </main>
                <WhatsAppFloat />
                <Toaster position="bottom-center" richColors />
            </div>
        </ErrorBoundary>
    );
}

export default App;
